(function () {
  'use strict';

  var CACHE_PREFIX = 'dd_vl_';
  var CACHE_TTL = 300000; // 5 minutes

  function getConfig() {
    return window.__ddVariantLoaderConfig || null;
  }

  window.ddVariantLoader = {
    fetch: function (productHandle) {
      var cfg = getConfig();
      if (!cfg || !cfg.token) {
        return Promise.resolve([]);
      }

      var cacheKey = CACHE_PREFIX + productHandle;
      var cached = this.getCache(cacheKey);
      if (cached) return Promise.resolve(cached);

      var SF_TOKEN = cfg.token;
      var API_VERSION = cfg.version || '2026-04';

      var allVariants = [];
      var self = this;

      function sfFetch(query, variables) {
        return fetch('/api/' + API_VERSION + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': SF_TOKEN
          },
          body: JSON.stringify({ query: query, variables: variables })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('GraphQL fetch failed (' + r.status + ')');
            return r.json();
          });
      }

      var query = [
        'query VariantsPage($handle: String!, $first: Int!, $after: String) {',
        '  product(handle: $handle) {',
        '    variants(first: $first, after: $after) {',
        '      pageInfo { hasNextPage endCursor }',
        '      nodes {',
        '        id',
        '        availableForSale',
        '        selectedOptions { name value }',
        '        price { amount }',
        '        compareAtPrice { amount }',
        '        quantityAvailable',
        '        image { url }',
        '      }',
        '    }',
        '  }',
        '}'
      ].join('\n');

      function fetchPage(cursor) {
        return sfFetch(query, {
          handle: productHandle,
          first: 250,
          after: cursor || null
        })
          .then(function (data) {
            var product = data && data.data && data.data.product;
            if (!product) return allVariants;

            var nodes = product.variants && product.variants.nodes || [];
            var pageInfo = product.variants && product.variants.pageInfo;

            var pageVariants = nodes.map(function (n) {
              var gid = String(n.id);
              var numericId = gid.indexOf('/') !== -1 ? gid.split('/').pop() : gid;
              var opts = {};
              (n.selectedOptions || []).forEach(function (o, i) {
                opts['option' + (i + 1)] = o.value;
              });
              // Storefront API does not expose Admin's `inventoryPolicy` field
              // directly. Infer it from `availableForSale` + `quantityAvailable`:
              //   - availableForSale=true  + qty>0          → in stock (deny or untracked)
              //   - availableForSale=true  + qty<=0         → continue-selling
              //   - availableForSale=true  + qty=null       → untracked, treat as in stock
              //   - availableForSale=false                  → deny + OOS
              // Downstream consumers (dd-swatch-selector.isCustomSellableVariant,
              // updateCardHint) must keep this contract in sync with the Liquid
              // shape produced by snippets/dd-swatch-options.liquid.
              var qty = (typeof n.quantityAvailable === 'number') ? n.quantityAvailable : null;
              var policy;
              if (!n.availableForSale) {
                policy = 'deny';
              } else if (qty !== null && qty <= 0) {
                policy = 'continue';
              } else {
                policy = 'deny';
              }
              return {
                id: parseInt(numericId, 10),
                available: n.availableForSale,
                price: Math.round(parseFloat(n.price.amount) * 100),
                compare_at_price: n.compareAtPrice ? Math.round(parseFloat(n.compareAtPrice.amount) * 100) : null,
                option1: opts.option1 || null,
                option2: opts.option2 || null,
                option3: opts.option3 || null,
                inventory_quantity: qty,
                inventory_policy: policy,
                inventory_management: qty === null ? null : 'shopify',
                image_url: n.image && n.image.url || null
              };
            });

            allVariants = allVariants.concat(pageVariants);

            if (pageInfo && pageInfo.hasNextPage && pageInfo.endCursor) {
              return fetchPage(pageInfo.endCursor);
            }
            self.setCache(cacheKey, allVariants);
            return allVariants;
          });
      }

      return fetchPage(null).then(function (res) {
        return res;
      }).catch(function (err) {
        console.warn('[dd-variant-loader]', err.message);
        return [];
      });
    },

    getCache: function (key) {
      try {
        var raw = sessionStorage.getItem(key);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (Date.now() - parsed.ts > CACHE_TTL) {
          sessionStorage.removeItem(key);
          return null;
        }
        return parsed.data;
      } catch (e) { return null; }
    },

    setCache: function (key, data) {
      try {
        sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data }));
      } catch (e) { /* quota exceeded */ }
    }
  };
})();
